import { render, staticRenderFns } from "./WkDep.vue?vue&type=template&id=0cba2dfc&scoped=true"
import script from "./WkDep.vue?vue&type=script&lang=js"
export * from "./WkDep.vue?vue&type=script&lang=js"
import style0 from "./WkDep.vue?vue&type=style&index=0&id=0cba2dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba2dfc",
  null
  
)

export default component.exports